module.exports = __webpack_public_path__ + "static/media/callcenter2.13f154ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/proyectos/software/callcenter2.png
// module id = 208
// module chunks = 0